module.exports = __webpack_public_path__ + "img/eleiko-strengthwear-back.f567bb7e.png";